import { useEffect, useRef, useState } from "react";
import { init } from "pptx-preview";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { saveBlob } from "@/lib/api";

export const PptPreviewDialog = ({ file, onClose }) => {
  const ref = useRef(null);
  const [rendering, setRendering] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!file) return undefined;
    let previewer;
    let alive = true;
    setRendering(true);
    setError(null);
    const t = setTimeout(async () => {
      try {
        const width = Math.min(ref.current.clientWidth - 8, 1100);
        previewer = init(ref.current, { width, height: Math.round(width * 9 / 16), mode: "list" });
        await previewer.preview(await file.blob.arrayBuffer());
      } catch (e) {
        if (alive) setError("Pratinjau gagal ditampilkan. File tetap bisa diunduh.");
      } finally {
        if (alive) setRendering(false);
      }
    }, 50);
    return () => { alive = false; clearTimeout(t); previewer?.destroy?.(); };
  }, [file]);

  return (
    <Dialog open={!!file} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-6xl w-[96vw] p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="flex flex-wrap items-center justify-between gap-3 pr-8">
            <span className="truncate text-base">Pratinjau · {file?.name}</span>
            <Button data-testid="ppt-preview-download-button" size="sm" onClick={() => saveBlob(file.blob, file.name)}>
              <Download className="mr-1.5 h-4 w-4" />Unduh PPT
            </Button>
          </DialogTitle>
        </DialogHeader>
        <p className="text-xs text-muted-foreground">Pratinjau di browser bisa sedikit berbeda dari PowerPoint (font &amp; grafik). Hasil akhir mengikuti file unduhan.</p>
        {rendering && <div className="flex items-center gap-2 py-6 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" />Menyiapkan pratinjau…</div>}
        {error && <p data-testid="ppt-preview-error" className="rounded bg-amber-50 p-3 text-sm text-amber-800">{error}</p>}
        <div data-testid="ppt-preview-container" ref={ref} className="max-h-[72vh] overflow-y-auto rounded-lg bg-slate-100 p-1" />
      </DialogContent>
    </Dialog>
  );
};
